'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  fontSize: _reactackleCore.fontSizeBody,
  lineHeight: 1.2,
  borderRadius: _reactackleCore.radiusDefault,
  backgroundColor: _reactackleCore.colorPaletteGrey300,
  textColor: _reactackleCore.bodyFontColor,

  content: {
    paddingX: (0, _reactackleCore.bmodule)(1),
    paddingY: (0, _reactackleCore.bmodule)(0.5),
    iconTextOffset: (0, _reactackleCore.bmodule)(1),
    alignY: 'top' // one of ['top', 'center', 'bottom']
  },

  icon: {
    height: 24,
    width: null,
    imgHeight: 20,
    imgWidth: null,
    color: 'currentColor',
    opacity: 1
  },

  removeIcon: {
    iconTextSpacing: (0, _reactackleCore.bmodule)(0.5),
    height: 24,
    width: null,
    imgHeight: 20,
    imgWidth: null,

    state: {
      color: _reactackleCore.bodyFontColor,
      backgroundColor: 'transparent',

      hover: {
        color: null, // will take 'default' if null
        backgroundColor: 'rgba(0,0,0,0.2)' // will take 'default' if null
      },

      focus: {
        color: null, // will take 'hover' if null
        backgroundColor: null // will take 'hover' if null
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tag/dist/styles/theme.js
// module id = 835
// module chunks = 0